import { render, staticRenderFns } from "./Sell-my.vue?vue&type=template&id=3857b742&scoped=true&"
import script from "./Sell-my.vue?vue&type=script&lang=js&"
export * from "./Sell-my.vue?vue&type=script&lang=js&"
import style0 from "./Sell-my.vue?vue&type=style&index=0&id=3857b742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3857b742",
  null
  
)

export default component.exports